var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('el-row',{staticClass:"integration-available-grid"},[_c('el-col',{attrs:{"span":4}},[_c('FreteRapidoComponent',{ref:"freteRapido"})],1),_c('el-col',{attrs:{"span":4}},[_c('IntelipostComponent',{ref:"intelipost"})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }